import React from "react";
import {
  Formatter,
  WSDataItem,
  WSList,
  WSPanel,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import { ISignedDocument } from "@wingspanhq/signed-documents/dist/lib/interfaces";
import { FormatterInput } from "@wingspanhq/fe-component-library/dist/utils/formatters/formatter";

const formatter = new Formatter({
  noDataIndicator: "–",
  trueIndicator: "Yes",
  falseIndicator: "No"
});

export const SignaturesFieldsWidget: React.FC<{
  signedDocument?: ISignedDocument;
}> = ({ signedDocument }) => {
  if (!signedDocument?.responseItems?.length) {
    return null;
  }

  return (
    <WSList gap="S">
      <WSSectionToolbar title="E-signature fields" />
      <WSPanel>
        <WSList>
          {signedDocument.responseItems.map(({ name, value, type }, index) => {
            let parsedValue: FormatterInput = value;

            if (type === "date_signed") {
              parsedValue = new Date(value);
            }

            return (
              <WSDataItem
                formatter={formatter}
                formatterOptions={{
                  dateType: "monthDayYear"
                }}
                key={index}
                label={name}
                value={parsedValue}
              />
            );
          })}
        </WSList>
      </WSPanel>
      {}
    </WSList>
  );
};
